"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeAvatar = exports.EmployeeAvatarType = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var colors_1 = require("../../theme/colors");
var avatar_1 = require("../avatar");
var EmployeeAvatarType;
(function (EmployeeAvatarType) {
    EmployeeAvatarType["AccountManager"] = "AM";
    EmployeeAvatarType["CustomerService"] = "CSA";
    EmployeeAvatarType["Producer"] = "PD";
})(EmployeeAvatarType = exports.EmployeeAvatarType || (exports.EmployeeAvatarType = {}));
var getEmployeeColor = function (employeeType) {
    if (employeeType === EmployeeAvatarType.AccountManager) {
        return colors_1.colors.brand[400];
    }
    if (employeeType === EmployeeAvatarType.Producer) {
        return colors_1.colors.steel[500];
    }
    if (employeeType === EmployeeAvatarType.CustomerService) {
        return colors_1.colors.steel[400];
    }
    return undefined;
};
exports.EmployeeAvatar = (0, react_1.forwardRef)(function (props, ref) {
    var employeeType = props.employeeType, sizeInPixels = props.sizeInPixels, disabled = props.disabled, imageUrl = props.imageUrl, initials = props.initials, isActive = props.isActive, onClick = props.onClick;
    return (react_1.default.createElement(avatar_1.Avatar, { sizeInPixels: sizeInPixels, disabled: disabled, imageUrl: imageUrl, initials: initials, isActive: isActive, onClick: onClick, badgeColor: getEmployeeColor(employeeType), badgeText: employeeType, ref: ref }));
});
//# sourceMappingURL=index.js.map